module.exports = __webpack_public_path__ + "img/332fc4f1-cbad-4485-96f3-6fdf077d36c9.bb5070d1.png";